import React, { useState, useEffect } from 'react';

import HomeHeader from './Header'

function HeaderWrapper(props) {
    

    useEffect(() => {

    }, []);
    return (

        <div className="HomeHeaderWrapper" style={{ backgroundColor: "hsl(245, 40%, 98%)", width: "100%"}}>

            <HomeHeader data={props.data}/>
        </div>
    );
}

export default HeaderWrapper;